/* eslint-disable no-console */
/* eslint-disable max-len */
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useContext, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { LanguageContext } from '../../../libs/Context';
import { IoIosInformationCircleOutline } from 'react-icons/io';

const CreateEditText = (props) =>
{
	const optionsObj = {
		create : props?.create,
		edit   : props?.edit
	};

	return (
		<span className='lightTxt'>{optionsObj[props?.option] || 'Would you like to assign this prospect to selected employee?' }</span>
	);
};

const button2 = (props) =>
{
	const isTask = props?.from === 'task';
	const isBusinessPros = props?.from === 'businessPros';
	const isFeedCreate = props?.from === 'feedCreate';
	const isCreateOrEdit = props?.option === 'create' || props?.option === 'edit';

	const buttonVariant = isBusinessPros || isFeedCreate || isCreateOrEdit ? 'contained' : 'text';
	const buttonClass = isBusinessPros || isFeedCreate || isCreateOrEdit ? 'whiteTxt' : '';

	const handleClick = () =>
	{
		if (props?.id !== undefined)
		{
			props?.handleConfirm?.(props?.id);
		}
		else
		{
			(isBusinessPros ? props?.closeCallBack : props?.handleConfirm)?.();
		}
	};

	return (
		<div className='flexInline pdngHXS'>
			<Button
				disabled={props?.loading}
				disableElevation
				disableFocusRipple
				disableRipple
				disableTouchRipple
				onClick={isTask ? props?.handleConfirm : handleClick}
				variant={isTask ? undefined : buttonVariant}
				className={isTask ? undefined : buttonClass}
			>
				{props?.type || ''}
			</Button>
		</div>);
};

const button3 = (props) =>
{
	const { btn3Label = '', btn3Callback = () => {}, btn3Variant = '' } = props; // variant = primary || ''

	return (
		<div className='flexInline pdngHXS'>
			<Button
				disableElevation
				disableFocusRipple
				disableRipple
				disableTouchRipple
				onClick={btn3Callback}
				variant={btn3Variant === 'primary' ? 'contained' : undefined}
				className={btn3Variant === 'primary' ? 'whiteTxt' : undefined}
			>
				{btn3Label}
			</Button>
		</div>);
};

const NewDialogPopup = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { showCross = false, showButtonOne = true } = props;
	const checkformatType = props?.formatType === language.no ? props?.formatType : language?.yes;
	const [ clearChat, setClearChat ] = useState<boolean>(false);
	const [ changes, setChanges ] = React.useState(10);

	const handleChange = (event) =>
	{
		setChanges(event.target.value);
	};
	const handleCheckBox = () =>
	{
		setClearChat(!clearChat);
	};

	const handleClickFun = () =>
	{
		console.log("handleClickFun consoled.....", props );
		if (props?.from === 'businessPros')
		{
			props?.handleConfirm();
		}
		else if (props?.actionMenu && props?.actionMenu === 'exit_chat')
		{
			props?.closeCallBack(clearChat);
		}
		else
		{
			props?.closeCallBack();
		}
	};

	return (
		<Dialog open={props?.open} maxWidth='xs' fullWidth>
			{(props?.renderFrom === 'contracts' || props?.renderFrom === 'contractStamp' || showCross) &&
			<DialogTitle>
				<div className='flexRow justifyEnd pointer' onClick={props?.handleClose}>
					<CloseIcon/>
				</div>
			</DialogTitle>}
			<DialogContent>
				<div className='flexCol justifyCntr alignCntr'>
					<div className='flexRow imgAvatarMD invertGray'>
						{props.icon
							? <img src={props.icon} alt='dialog-popup' className='invertGray'/>
							: <img src='/images/icons/dialogPopup.svg' alt='dialog-popup'/>}
					</div>
					<div className='flexRow wordBreakWord justifyCntr alignCntr textCntr pdngTSM'>
						{props?.from === 'feedCreate'
							?	<span className='lightTxt'>{props?.label}</span>
							:	<CreateEditText option={props?.option} create={props?.create} edit={props?.edit} />
						}
					</div>
					{props.resource &&
					<div className='flexRow wordBreakWord justifyCntr alignCntr pdngTSM lightTxt'>
						<IoIosInformationCircleOutline/><span className='lightTxt pdngHXS'>{props?.secondTxt}</span>
					</div>}
					{props?.actionMenu && props?.actionMenu === 'exit_chat' && (
						<div className='flexRow alignCntr lightTxt' style={{ marginTop: '12px' }}>
							<Checkbox onChange={handleCheckBox} checked={clearChat}/>
							<span>Delete Chat</span>
						</div>
					)}
					{props?.showCheckboxTxt && (
						<div className='flexRow pdngTXS alignStart'>
							<Checkbox checked/>
							<span className='pdngTXXS'>{props.checkboxLabelTxt}</span>
						</div>
					)}
				</div>
			</DialogContent>
			{ props?.renderFrom !== 'contractStamp' && <DialogActions>
				<div className='flexRow  pdngXS justifyEnd'>
					{ props.resource &&
					<div className='flexMinWidthRow'>
						<FormControl sx={{ m: 1, minWidth: 120 }} size='small'>
							<Select
								labelId='demo-select-small-label'
								id='demo-select-small'
								value={changes}
								placeholder='Only here'
								onChange={handleChange}
							>
								<MenuItem value={10}
									sx={{
										color : changes === 10 ? '#24A4C4' : 'inherit'
									}}
								>Only here</MenuItem>
								<MenuItem value={20}
									sx={{
										color : changes === 20 ? '#24A4C4' : 'inherit'
									}}
								>Everywhere</MenuItem>
							</Select>
						</FormControl>
					</div>
					}
					<div className='flexAutoROw justifyEnd '>
						{showButtonOne &&
						<div className='flexInline pdngHXS'>
							<Button
								disableElevation
								disableFocusRipple
								disableRipple
								disableTouchRipple
								onClick={handleClickFun}
							>
								{props?.from === 'feedCreate' ? props?.formatType : checkformatType}
							</Button>
						</div>}
						{button2(props)}
						{props?.btn3Label && button3(props)}
					</div>
				</div>

			</DialogActions>}
		</Dialog>
	);
};

export default NewDialogPopup;